import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import router from 'next/router';

import type { MenuHierarchyRecordModelType } from '@/models/api';
import { useStore } from '@/models/root-store';

interface BreadcrumbProps {
  menuHierarchies: MenuHierarchyRecordModelType[];
}
const Breadcrumb = observer(({ menuHierarchies }: BreadcrumbProps) => {
  const { action } = router.query;

  if (_.isEmpty(menuHierarchies)) return null;
  const {
    cartStore: { draftCart },
  } = useStore();
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center ">
        {menuHierarchies.map((menuHierarchy, index) => (
          <li key={menuHierarchy.id} className="inline-flex items-center">
            <Link
              href={{
                pathname: menuHierarchy?.pagePaths?.[0]?.path ?? '/menu',
                ...(!action &&
                  draftCart.mode && {
                    query: {
                      ...(draftCart.mode && { mode: draftCart.mode }),
                    },
                  }),
              }}
              className={`${
                index === menuHierarchies.length - 1
                  ? 'text-black'
                  : 'text-grey-dark '
              } font-interMedium text-sm hover:underline md:text-sm lg:text-base  mobile-375:text-xs`}
            >
              {menuHierarchy.name}
            </Link>
            {index !== menuHierarchies.length - 1 && (
              <span className="mx-1 text-grey-dark md:mx-1.5">/</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
});

export default Breadcrumb;
